import { CreateFocusCss, isPhoneInLandscape } from '../../../../styles'
import type { Tokens } from '../../../../theming/types'
import { scrollShadow } from '../../../../utilities'

export default (config: { tokens: Tokens }) => {
  const { tokens } = config
  return {
    default: {
      body: {
        padding: '24px',

        [isPhoneInLandscape]: {
          padding: '10px',
        },
      },

      shadowTop: {
        ...scrollShadow({
          direction: 'down',
          height: '4px',
          shadowColorStart: tokens.elevationContainerScrollTop,
          shadowColorEnd: tokens.elevationContainerScrollBottom,
        }),
      },

      shadowBottom: {
        ...scrollShadow({
          direction: 'up',
          height: '4px',
          shadowColorStart: tokens.elevationContainerScrollTop,
          shadowColorEnd: tokens.elevationContainerScrollBottom,
        }),
      },
    },

    scrollShadow: {
      body: {
        ...CreateFocusCss(tokens.focusInner),
      },
    },
  } as const
}
